import { Image, Link, Text, useBreakpointValue } from '@chakra-ui/react';

import { StandUpGuy } from '../../../assets/Images';
import getSearchPhoneNumbers from '../../../utils/getSearchPhoneNumbers';
import { DealWithFarthestState } from '../utils';
import DashboardStateCard from './DashboardStateCard';

const ClosingDashboard = ({
  deal,
  showPayoffIntelligenceVariation,
}: {
  deal?: DealWithFarthestState;
  showPayoffIntelligenceVariation?: boolean;
}) => {
  const phoneNumber = getSearchPhoneNumbers();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <DashboardStateCard
      deal={deal}
      header="Great news!"
      subheader={
        showPayoffIntelligenceVariation ? null : 'We found you an approval for your lease buyout.'
      }
      body={
        <Text>
          {showPayoffIntelligenceVariation
            ? 'We found you an approval for your lease buyout. '
            : ''}
          We'll be calling soon to walk you through your next steps—get ready to make it official.{' '}
          {showPayoffIntelligenceVariation ? (
            ''
          ) : (
            <>
              In the meantime, if you have any questions, give us a call at{' '}
              <Link href={`tel:+1-${phoneNumber}`}>{phoneNumber}</Link>.
            </>
          )}
        </Text>
      }
      image={
        isMobile && showPayoffIntelligenceVariation ? null : (
          <Image p={4} src={StandUpGuy} alt="Stand Up" />
        )
      }
    />
  );
};

export default ClosingDashboard;
